'use client';

import { Box, Grid, Typography, Paper } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';
import PublicIcon from '@mui/icons-material/Public';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { useTranslations } from 'next-intl';

const ICONS = [BusinessIcon, GroupsIcon, PublicIcon, MeetingRoomIcon];

const AboutStats = () => {
    const t = useTranslations('AboutPage.about_stats');

    const stats = [
        { value: t('stat_0_value'), label: t('stat_0_label'), icon: ICONS[0], currentDate: '' },
        { value: t('stat_1_value'), label: t('stat_1_label'), icon: ICONS[1], currentDate: t('stat_1_current_date') },
        { value: t('stat_2_value'), label: t('stat_2_label'), icon: ICONS[2], currentDate: '' },
        { value: t('stat_3_value'), label: t('stat_3_label'), icon: ICONS[3], currentDate: '' },
    ];

    return (
        <Box sx={{ py: 6 }}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 800, mb: 3 }}>
                {t('title')}
            </Typography>
            <Grid container spacing={4}>
                {stats.map((stat, index) => (
                    <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 4,
                                height: '100%',
                                textAlign: 'center',
                                borderRadius: '16px',
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Box sx={{
                                width: 48,
                                height: 48,
                                borderRadius: '50%',
                                backgroundColor: '#fef2f2',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mb: 2,
                                color: '#F15859'
                            }}>
                                <stat.icon />
                            </Box>
                            <Typography variant="h5" sx={{ fontWeight: 800, color: '#132c4b', mb: 1 }}>
                                {stat.value}
                            </Typography>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#64748b' }}>
                                {stat.label}
                            </Typography>
                            {stat.currentDate && (
                                <Typography variant="caption" sx={{ color: '#64748b' }}>
                                    {stat.currentDate}
                                </Typography>
                            )}
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default AboutStats;
